import React from "react";

interface MoneyFruitProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const MoneyFruit: React.FC<MoneyFruitProps> = ({
  fill,
  onClick,
  width,
  height,
}) => {
  return (
    <svg
      width={width ?? "25"}
      height={height ?? "25"}
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M10.554 12.0414C11.0477 12.0414 11.4468 12.4414 11.4468 12.9342V13.3806H11.8932C12.3869 13.3806 12.786 13.7797 12.786 14.2735C12.786 14.7672 12.3869 15.1663 11.8932 15.1663H10.1075C9.86202 15.1663 9.66114 15.3672 9.66114 15.6127C9.66114 15.8582 9.86202 16.0591 10.1075 16.0591H11.0004C12.2316 16.0591 13.2324 17.06 13.2324 18.2912C13.2324 19.3697 12.4646 20.2706 11.4468 20.4777V20.9697C11.4468 21.4634 11.0477 21.8625 10.554 21.8625C10.0602 21.8625 9.66114 21.4634 9.66114 20.9697V20.5232H8.76831C8.27458 20.5232 7.87549 20.1242 7.87549 19.6304C7.87549 19.1367 8.27458 18.7376 8.76831 18.7376H11.0004C11.2459 18.7376 11.4468 18.5367 11.4468 18.2912C11.4468 18.0457 11.2459 17.8448 11.0004 17.8448H10.1075C8.87634 17.8448 7.87549 16.8439 7.87549 15.6127C7.87549 14.5342 8.64332 13.6333 9.66114 13.4262V12.9342C9.66114 12.4414 10.0602 12.0414 10.554 12.0414Z"
        fill={fill ?? "#EAECF0"}
      />
      <path
        d="M20.7205 0.952488C15.7555 -1.1269 11.8351 0.482863 10.3191 3.04795C8.33972 0.617679 4.58986 0.448935 1.4989 0.891776C0.9766 0.966773 0.630185 1.47836 0.759644 1.99263C1.83996 6.31568 4.99163 8.61917 9.6611 7.45404V8.97184C5.64964 9.41825 2.51851 12.8262 2.51851 16.9546C2.51851 21.3857 6.12284 24.99 10.5539 24.99C14.985 24.99 18.5893 21.3857 18.5893 16.9546C18.5893 12.8262 15.4582 9.41736 11.4468 8.97184V6.59157C16.2234 7.9683 19.6223 6.89066 21.2223 2.05691C21.3687 1.61318 21.15 1.13284 20.7205 0.952488ZM2.79618 2.53993C5.65679 2.29976 9.11023 2.8292 9.60664 5.62642C6.4264 6.54871 3.98006 5.68803 2.79618 2.53993ZM16.8037 16.9537C16.8037 20.3991 13.9993 23.2035 10.5539 23.2035C7.10852 23.2035 4.30416 20.3991 4.30416 16.9537C4.30416 13.5083 7.10852 10.7039 10.5539 10.7039C13.9993 10.7039 16.8037 13.5083 16.8037 16.9537ZM11.5244 4.74967C12.0289 2.7301 14.9332 0.853385 19.2268 2.2953C17.7671 5.72285 15.0975 5.87909 11.5244 4.74967Z"
        fill={fill ?? "#EAECF0"}
      />
    </svg>
  );
};
export default MoneyFruit;
